import React from 'react';
import { Row } from 'react-bootstrap';
import { FaEraser } from 'react-icons/fa';
import { IoIosSearch } from 'react-icons/io';
import { MdOutlineCancel } from 'react-icons/md';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { useTransferenciaDePOS } from '../../contexts/TransferenciaDePOSContext';

export const ActButtons: React.FC = () => {
  const {
    handleSearch,
    handleCancel,
    handleClear,
    disable,
    searching,
    transferindo,
  } = useTransferenciaDePOS();

  return (
    <Row style={{ display: 'flex', gap: '0.5rem' }}>
      <CustomButtonNovo
        onClick={async () => {
          await handleSearch();
        }}
        label="Pesquisar"
        icon={IoIosSearch}
        disabled={disable.btnSearch || searching}
        showLoading={searching}
      />
      <CustomButtonNovo
        onClick={handleCancel}
        label="Cancelar"
        icon={MdOutlineCancel}
        disabled={disable.btnCancel || searching || transferindo}
        showLoading={false}
        variant="cancel"
      />
      <CustomButtonNovo
        onClick={handleClear}
        label="Limpar"
        icon={FaEraser}
        disabled={disable.btnClear || searching}
        showLoading={false}
        variant="clear"
      />
    </Row>
  );
};
